
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// A PrivateRoute to protect access to the home and admin pages
const AdminPrivateRoute = ({ allowedRoles, allowedTypes }) => {
  // Safely get user data from localStorage
  const userData = JSON.parse(localStorage.getItem("user"));

  
  const userRole = userData.role;
  const userType = userData.accountType;

  // If the role or type doesn't match allowed values, redirect to dashboard
  if (!userData || !allowedRoles.includes(userRole) || !allowedTypes.includes(userType)) {
    return <Navigate to="/HomePage" />;
  }

  // User has proper permissions, render the protected route
  return <Outlet />;
};

export default AdminPrivateRoute;